

































import { Messages } from "@/models/enums/messages.enum";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import {
  DATE_FORMAT_YYYY_MM_DD,
  DEFAULT_DATE_FORMAT,
} from "@/models/constants/date.constant";
import { accountingService } from "@/services/accounting.service";
import { useBlob, useDate } from "@/hooks";
import { WrappedFormUtils } from "ant-design-vue/types/form/form";

@Component
export default class BalanceSheetReport extends Vue {
  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  Messages = Messages;
  form!: WrappedFormUtils;
  page = 1;
  limit = 10;
  params: RequestQueryParamsModel = {};
  totalData = 0;
  loading = {
    download: false,
    print: false,
    loadingBranch: false,
    loadingDownload: false,
  };
  formRules = {
    asOfDate: {
      label: "lbl_as_of_date",
      name: "asOfDate",
      placeholder: "lbl_as_of_date_placeholder",
      decorator: [
        "asOfDate",
        {
          rules: [
            {
              required: true,
              message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
            },
          ],
        },
      ],
    },
  };

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "BalanceSheetReport" });
  }

  handleDownload() {
    this.form.validateFields((err, res) => {
      if (err) return;
      const { toEndDay } = useDate();
      const params: RequestQueryParamsModel = {
        date: toEndDay(res.asOfDate).format(),
      };
      this.loading.loadingDownload = true;
      params.params = this.checkParams(res);
      const { toDownload } = useBlob();
      accountingService
        .downloadReportBalanceSheet(params)
        .then(response => {
          toDownload(response, "balance-sheet.xlsx");
        })
        .finally(() => (this.loading.loadingDownload = false));
    });
  }
  checkValue(value): string {
    if (value && !value.includes("undefined")) {
      return value;
    } else {
      return ",ALL";
    }
  }
  checkParams(res): string {
    let params = "";
    // company is mandatory
    params += this.$store.state.authStore.authData.companyName;
    params += this.checkValue(
      `,${
        res["asOfDate"]
          ? moment(res["asOfDate"]).format(DATE_FORMAT_YYYY_MM_DD)
          : undefined
      }`
    );

    return params;
  }
  handleReset(): void {
    this.form.resetFields();
  }
}
